

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"}, rest), ["\n   ", h('path', {"fill":"currentColor","d":"M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6M20 4V16H8V4H20M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M12 14.5V5.5L18 10L12 14.5Z"}, []), "\n"]);
};

        